
export const couponVoucherType = Object.freeze({
    Coupon: 1,
    Voucher: 2,
});

export const couponVoucherTypeOptions = [
    { label: "Coupon", value: couponVoucherType.Coupon },
    { label: "Voucher", value: couponVoucherType.Voucher },
]

export const couponVoucherTypeLabels = {
    [couponVoucherType.Coupon]: "Coupon",
    [couponVoucherType.Voucher]: "Voucher",
};